import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { normalizeLang } from '@/mocks/sections';

export default function LanguageSync() {
  const { i18n } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    const firstSegment = pathname.split('/').filter(Boolean)[0];
    if (firstSegment === 'en' || firstSegment === 'de') {
      const target = normalizeLang(firstSegment);
      if (i18n.language !== target) {
        i18n.changeLanguage(target);
      }
    }
  }, [pathname, i18n]);

  return null;
}